/* Local, explainable sizing guidance. No personal data is transmitted or persisted. */
(() => {
  const alphabet=['XXS','XS','S','M','L','XL','XXL','XXXL','4XL','5XL'];
  const norm=v=>String(v||'').trim().toUpperCase().replace(/^2XL$/,'XXL').replace(/^3XL$/,'XXXL');
  function recommend({sizes,upper,lower,isSet=false,fit='normal',chest,waist,table=[]}){
    const list=[...new Set(sizes)];const alpha=list.every(s=>alphabet.includes(norm(s)));
    const rank=s=>alpha?alphabet.indexOf(norm(s)):Number.parseFloat(s);
    const sorted=list.sort((a,b)=>rank(a)-rank(b));
    const first=rank(upper),second=isSet?rank(lower):first;
    if(!sorted.length||!Number.isFinite(first)||first<0||!Number.isFinite(second)||second<0)return{size:null,reason:'noMatch',upper,lower};
    let target=Math.max(first,second),measured=false;
    const dimension=(key,value,allowance)=>{if(!value||!table.length)return null;const rows=table.filter(r=>Number(r[key])>=Number(value)+allowance&&sorted.includes(r.size));return rows.sort((a,b)=>Number(a[key])-Number(b[key]))[0]?.size||null;};
    if(chest||waist){
      const top=chest?dimension('chest',chest,fit==='loose'?18:fit==='fitted'?8:12):null;
      const bottom=waist?dimension('waist',waist,fit==='loose'?2:0):null;
      if(table.length&&((chest&&!top)||(waist&&!bottom)))return{size:null,reason:'measurementOutside',upper,lower};
      if(top||bottom){target=Math.max(target,top?rank(top):-1,bottom?rank(bottom):-1);measured=true;}
    }
    let candidate=sorted.find(s=>rank(s)>=target);
    if(!candidate)return{size:null,reason:'outside',upper,lower};
    let atLimit=false;
    if(fit==='loose'&&!measured){const i=sorted.indexOf(candidate);if(sorted[i+1])candidate=sorted[i+1];else atLimit=true;}
    return{size:candidate,upper,lower,conflict:isSet&&Math.abs(first-second)>1,reason:measured?'measured':isSet?'setEstimate':'estimate',atLimit};
  }
  const api={recommend,norm};if(typeof module!=='undefined'&&module.exports)module.exports=api;else window.IKAOFitEngine=api;
})();
